import React, { useEffect, useState } from "react";

import { FaCirclePlus } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

import { exportToExcel } from 'react-json-to-excel';
import MonthYearPicker from "../../../../../components/Input/MonthYearPicker";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService";
import store from "../../../../../store/store";
import Loading from "../../../../home/components/Loading";
import Container from "../../../components/Container";
import styles from "./reports.module.scss";
import imgOwnDeliveryReports from "../../../../../assets/images/own_delivery_reports.svg";

const OwnDeliveryReports = () => {
  const { auth } = store.getState();
  const { user } = auth;
  const history = useHistory();

  const api = new BrComerceApiService();

  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState("")
  const [ownDeliveryReports, setOwnDeliveryReports] = useState([]);
  const [displaySuperExpressItems, setDisplaySuperExpressItems] = useState([]);
  const [displayImg, setDisplayImg] = useState(true);

  useEffect(() => {
    window.setPageTitle("Relatórios - Super Expresso");

    if (user.profile !== "admin") {
      history.push("/");
    }
  }, []);

  const handleOnChangeCalendarPeriod = e => {
    const date = e.split("/");
    setDate(`${date[1]}/${date[0]}/01`);
  };

  const loadOwnDeliveryReports = async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        url: `/reports?date=${date}`,
      });

      setOwnDeliveryReports(response);
      setDisplaySuperExpressItems(response?.slice(0, 100))
    } catch (e) {
      Swal.fire({
        text: "Erro ao carregar lista de envios",
        title: "Envios Super Expresso",
        icon: "error"
      });
    } finally {
      setLoading(false);
      setDisplayImg(false);
    }
  }

  return (
    <>
      <Loading isLoading={loading} />
      <Container title="Relatórios - Super Expressa">
        <div className={styles.contentBody}>
          <div className={styles.filters}>

            <div className={styles.filterDateInput}>
              <MonthYearPicker
                placeholder="Selecione no calendário"
                onChange={(e) => handleOnChangeCalendarPeriod(e)}
              />
            </div>

            <button
              type="button"
              className={styles.btnAddTable}
              onClick={() => loadOwnDeliveryReports()}
              disabled={!date?.length}
            >
              <FaCirclePlus fill="#fff" color="#fff" />
              <span>Gerar novo relatório</span>
            </button>

            <button
              type="button"
              onClick={() => {
                const dateSplit = date.split("/");
                const newDate = `${dateSplit[1]}_${dateSplit[0]}`;

                exportToExcel(
                  ownDeliveryReports,
                  `Relatório Super Expressa - ${newDate}`
                )
              }}
              className={styles.buttonDownload}
              disabled={!ownDeliveryReports?.length}
            >
              <FiDownload />
              <span>Baixar relatório</span>
            </button>
          </div>
          <div className={styles.contentTable}>
            <table className={styles.tableContainer}>
              <thead>
                <tr>
                  <th width="10">Etiqueta</th>
                  <th width="9">Competência</th>
                  <th width="9">ID</th>
                  <th width="9">Envio</th>
                  <th width="9">Coleta</th>
                  <th width="9">Pedido</th>
                  <th width="9">Valor</th>
                  <th width="9">Peso</th>
                  <th width="10">Cep</th>
                  <th width="5%">Motorista</th>
                </tr>
              </thead>
              {!!displayImg &&
                <tbody>
                  <th colSpan={10} style={{ textAlign: 'center', padding: '40px' }}>
                    <img
                      src={imgOwnDeliveryReports}
                      alt="Imagem de uma figura feminina com uma caixa de seleção no fundo"
                      className={styles.imgOwnDeliveryReports}
                    />
                  </th>
                </tbody>}
              <tbody>
                {
                  !!displaySuperExpressItems?.length &&
                  displaySuperExpressItems?.map((row, index) => {
                    return (
                      <>
                        <tr key={row.ID}>
                          <td>{row?.Etiqueta}</td>
                          <td>{row?.Competência}</td>
                          <td>{row?.ID}</td>
                          <td>{row?.Envio}</td>
                          <td>{row?.Coleta}</td>
                          <td>{row?.Pedido}</td>
                          <td>{row?.Valor}</td>
                          <td>{row?.Peso}</td>
                          <td>{row?.CEP}</td>
                          <td><span>{row?.Motorista ?? "--"}</span></td>
                        </tr>
                        {
                          index === (displaySuperExpressItems?.length - 1) &&
                          <tr>
                            <td colSpan={10} style={{ textAlign: 'center', fontSize: "14px" }}>{"A tabela exibe apenas uma amostra dos dados. Clique em 'Baixar relatório' para ver o completo."}</td>
                          </tr>
                        }
                      </>
                    );
                  })
                }
              </tbody>
              {
                !displayImg && !displaySuperExpressItems?.length &&
                <tbody>
                  <th colSpan={10} style={{ textAlign: 'center', padding: '40px' }}>
                    <h4>Não foram encontrados resultados para essa pequisa.</h4>
                  </th>
                </tbody>
              }
            </table>
          </div>
        </div>
      </Container>
    </>
  )
}

export { OwnDeliveryReports };